import React, { useEffect, useState } from "react";

//UI Material
import {
  Box,
  Breadcrumbs,
  Card,
  Divider,
  Grid,
  Link,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

//Local components
import DataLoader from "../Components/basics/DataLoader";
import ErrorBox from "../Components/ErrorBox";
import ItemSummary from "../Components/inventory-page/ItemSummary";
import ItemInfo from "../Components/inventory-page/ItemInfo";
import { a11yProps, TabPanel } from "../Components/basics/TabPanel";
import EntriesTable from "../Components/inventory-page/EntriesTable";
import StockoutsTable from "../Components/inventory-page/StockoutsTable";

export default function Item() {
  // ==========> Component States<==========
  //State for store item data
  const [itemData, setItemData] = useState({});
  //State for loading
  const [dataLoader, setDataLoader] = useState(true);
  //State for error case
  const [dataError, setDataError] = useState(false);
  // State for tab value
  const [tabValue, setTabValue] = useState(0);

  // ==========> Component Functions <==========
  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
  };

  //Function to get item data from db
  const getItemData = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/inventory/get-item`,
        {
          id: new URLSearchParams(window.location.search).get("id"),
        }
      );
      const jsonResponse = await requestResponse.json();
      setItemData(jsonResponse.data);
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  // ==========> Component UseEffects <==========
  //UseEffect to get product data when rendering
  useEffect(() => {
    getItemData();
  }, []);

  // ==========> Component <==========
  if (dataLoader) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid
      container
      spacing={1}
      justifyContent="flex-start"
      textAlign="center"
      sx={{ padding: "15px" }}
    >
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/inventory">
            Inventario
          </Link>
          <Link underline="hover" color="text.primary" aria-current="page">
            {`Ítem ${new URLSearchParams(window.location.search).get("id")}`}
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <ItemSummary data={itemData} />
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Grid container spacing={1} alignItems="stretch" alignContent="stretch">
          <Grid item xs={12}>
            <ItemInfo data={itemData} getItem={getItemData} />
          </Grid>
          <Grid item xs={12}>
            <Card raised>
              <Grid container>
                <Grid item xs={12} sx={{ p: 2 }}>
                  <Box>
                    <Tabs
                      centered
                      indicatorColor="secondary"
                      textColor="secondary"
                      value={tabValue}
                      onChange={handleChange}
                      aria-label="inventory-transactions-tabs"
                    >
                      <Tab
                        label="Entradas"
                        sx={{ fontSize: "11px" }}
                        {...a11yProps(0)}
                      />
                      <Tab
                        label="Salidas"
                        sx={{ fontSize: "11px" }}
                        {...a11yProps(1)}
                      />
                    </Tabs>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
                  <TabPanel value={tabValue} index={0}>
                    <EntriesTable method="item" />
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    <StockoutsTable method="item" />
                  </TabPanel>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
